export const createCustomerQuery = `
 mutation CreateCustomer($input: CreateCustomerInput!) {
      createCustomer(input: $input) {
        code
        customer {
            id
            companyId
            storeId
            name
            type
            phone
            email
            tin
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            
            }

        }
    }
 }
`;

export const listCustomersQuery = `
 query GetCustomersList($input: ListCustomersInput!) {
      listCustomers(input: $input) {
        code
        customers {
            id
            companyId
            storeId
            name
            type
            phone
            email
            tin
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            
            }

        }
    }
 }
`;

export const getCustomerDetails = `
 query GetCustomerDetails($input: GetCustomerInput!) {
      getCustomer(input: $input) {
        code
        customer {
            id
            companyId
            storeId
            name
            type
            phone
            email
            tin
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            
            }

        }
    }
 }
`;

export const updateCustomerQuery = `
 mutation UpdateCustomer($input: UpdateCustomerInput!) {
      updateCustomer(input: $input) {
        code
        customer {
            id
            companyId
            storeId
            name
            type
            phone
            email
            tin
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            
            }

        }
    }
 }
`;

export const deleteCustomerQuery = `
 mutation DeleteCustomer($input: DeleteCustomerInput!) {
      deleteCustomer(input: $input) {
        code
       
    }
 }
`;
